import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Store } from '@ngxs/store';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { ProviderService } from '../../service/provider.service';
import { AuthState } from '../../store/authInfo/auth-state';
import { QuotationsheetComponent } from './quotationsheet/quotationsheet.component';

@Component({
  selector: 'app-provider-quotationsheet-manager',
  templateUrl: './provider-quotationsheet-manager.component.html',
  styleUrls: ['./provider-quotationsheet-manager.component.less']
})
export class ProviderQuotationsheetManagerComponent implements OnInit {

  @Input() pno: any; // 供应商编号
  pageIndex: number;
  pageSize: number;
  total = 0;
  loading = true;
  status = [
    {id: 0, name: '未成交'},
    {id: 1, name: '跟进中'},
    {id: 2, name: '已丢单'},
    {id: 3, name: '已下单'},
    {id: 4, name: '已付定金'},
    {id: 5, name: '已到款'},
    {id: 6, name: '已开票'},
    {id: 7, name: '已发货'},
    {id: 8, name: '已到货'},
    {id: 9, name: '已退货'},
    {id: 10, name: '已成交'}];
  // 查询结果
  data = [];
  validateForm: FormGroup;
  authState = null;
  checked = false;
  indeterminate = false;
  isShowLeft = true;
  isShowDown = false;
  setOfCheckedId = new Set<number>();
  constructor(
    private modalService: NzModalService,
    private message: NzMessageService,
    private providerService: ProviderService,
    private fb: FormBuilder,
    private store: Store,
  ) { }

  ngOnInit(): void {
    this.authState = this.store.selectSnapshot<any[]>(AuthState);
    this.validateForm = this.fb.group({
      qsNo: [null], // 供应商名称
      qsName: [null],
      status: [null],
      pno: this.pno
    });
    this.queryQsData(1);
  }
  addQs(){
    const modal = this.modalService.create({
      nzTitle: '添加报价单',
      nzContent: QuotationsheetComponent,
      nzStyle: { top: '20px' },
      nzBodyStyle: { paddingRight: '0px', paddingLeft: '42px' },
      nzWidth: 700,
      nzComponentParams: {
        code: 0, // 添加
        pno: this.pno
      },
      nzOnOk: (ev) => {
        const  form  = ev.getQsForm();
        const filePaths =  ev.getFilePathList();
        if (!this.validateFormData(form)){
          this.message.warning('数据未验证通过');
          return false;
        }else{
          const  qs = {
            qsName : form.value.qsName,
            qsNo : form.value.qsNo,
            qsMoney: form.value.qsMoney,
            qsDesc: form.value.qsDesc,
            qsDate: form.value.qsDate,
            mark: form.value.mark,
            status: form.value.status,
            qsBidder: form.value.qsBidder,
            createBy: this.authState.userInfo.userId,
            pno: form.value.pno,
            filePaths
          };
          // tslint:disable-next-line:no-shadowed-variable
          this.providerService.addQuotationSheet(qs).subscribe((res: any) => {
            if (res.code === 200){
              this.queryQsData(1);
              this.message.success('添加成功');
              modal.close();
            }else{
              if (res.code === 302){
                this.message.error(res.msg);
              }else{
                this.message.error('添加失败');
              }
            }
          });
          return false;
        }
      },
      nzOnCancel: (ev) => {
      }
    });
  }
  viewQs(item){
    const modal = this.modalService.create({
      nzTitle: '查看报价单',
      nzContent: QuotationsheetComponent,
      nzStyle: { top: '20px' },
      nzBodyStyle: { paddingRight: '0px', paddingLeft: '42px' },
      nzWidth: 700,
      nzComponentParams: {
        code: 2, // 查看
        pno: this.pno,
        qsid: item.id // 供应商报价单id
      },
      nzOnOk: (ev) => {
      },
      nzOnCancel: (ev) => {
      }
    });
  }
  editQs(item){
    const modal = this.modalService.create({
      nzTitle: '修改供应商报价单',
      nzContent: QuotationsheetComponent,
      nzStyle: { top: '20px' },
      nzBodyStyle: { paddingRight: '0px', paddingLeft: '42px' },
      nzWidth: 700,
      nzComponentParams: {
        code: 1, // 编辑
        pno: this.pno,
        qsid: item.id // 供应商报价单id
      },
      nzOnOk: (ev) => {
        this.modalService.confirm({
            nzTitle: '修改报价单',
            nzContent: '确定要修改报价单内容？',
            nzOkText: '确定',
            nzCancelText: '取消',
            nzOnOk: () => {
              const  form  = ev.getQsForm();
              const filePaths =  ev.getFilePathList();
              if (!this.validateFormData(form)){
                this.message.warning('数据未验证通过');
              }else{
                const  qs = {
                  id: item.id,
                  qsName : form.value.qsName,
                  qsNo : form.value.qsNo,
                  qsMoney: form.value.qsMoney,
                  qsDesc: form.value.qsDesc,
                  qsDate: form.value.qsDate,
                  mark: form.value.mark,
                  status: form.value.status,
                  qsBidder: form.value.qsBidder,
                  updateBy: this.authState.userInfo.userId,
                  guaranteePeriod: form.value.guaranteePeriod,
                  pno: form.value.pno,
                  filePaths
                };
                // tslint:disable-next-line:no-shadowed-variable
                this.providerService.updateQuotationSheet(qs).subscribe((data: any) => {
                  if (!this.isEmpty(data)){
                    // this.queryContractData(1);
                    this.message.success('修改成功');
                    this.queryQsData(1);
                    modal.close();
                  }else{
                    this.message.error('修改失败');
                  }
                });
              }
              return true;
            }
        });
        return false;
      },
      nzOnCancel: (ev) => {
      }
    });
  }
  onAllChecked(checked: boolean): void {
    this.data.forEach(item => this.updateCheckedSet(item.id, checked));
    this.refreshCheckedStatus();
  }

  updateCheckedSet(id: number, checked: boolean): void {
    if (checked) {
      this.setOfCheckedId.add(id);
    } else {
      this.setOfCheckedId.delete(id);
    }
  }
  onItemChecked(id: number, checked: boolean): void {
    this.updateCheckedSet(id, checked);
    this.refreshCheckedStatus();
  }
  refreshCheckedStatus(): void {
    this.checked = this.data.every(item => this.setOfCheckedId.has(item.id));
    this.indeterminate = this.data.some(item => this.setOfCheckedId.has(item.id)) && !this.checked;
  }
  onPageIndexChange(pageIndex) {
    this.pageIndex = pageIndex;
    this.queryQsData(0);
  }
  // 提交表单
  submitForm() {
    this.validateForm.setValue({
      qsNo: this.validateForm.value.qsNo,
      qsName: this.validateForm.value.qsName,
      status: this.validateForm.value.status,
      pno: this.pno
    });
    this.queryQsData(1);
  }
  // 重置表单
  resetForm() {
    this.validateForm.setValue({
      qsNo: null,
      qsName: null,
      status: null,
      pno: this.pno
    });
    this.queryQsData(1);
  }
  queryQsData(flag: number) {
    if (flag === 1) {
      this.pageIndex = 1;
      this.pageSize = 10;
    }
    // tslint:disable-next-line:max-line-length
    const condition = {
      qsNo: this.validateForm.value.qsNo,
      qsName: this.validateForm.value.qsName,
      status: this.validateForm.value.status,
      pno: this.pno,
      pageIndex: this.pageIndex,
      pageSize: this.pageSize
    };
    this.providerService.getProviderQsByCondition(condition).subscribe((data: any) => {
      this.loading = false;
      this.data = data.list;
      this.total = data.total;
    });
  }
  delete(){
    this.providerService.batchDeleteQuotationsheets(this.setOfCheckedId).subscribe((result: any) => {
      if (result.code === 200){
        this.queryQsData(1);
      }else{
        this.message.error(result.msg);
      }
    });
  }
  public validateFormData(validateForm) {
    // tslint:disable-next-line:forin
    for (const i in validateForm.controls) {
      validateForm.controls[i].markAsDirty();
      validateForm.controls[i].updateValueAndValidity();
    }
    return validateForm.valid;
  }
  openOtherCondition(){
    this.isShowLeft = false;
    this.isShowDown = true;
  }

  closeOtherCondition(){
    this.isShowLeft = true;
    this.isShowDown = false;
  }
  isEmpty(obj: any) {
    if (typeof obj === 'undefined' || obj === null || obj === '') {
      return true;
    } else {
      return false;
    }
  }
  convertInt(str: any){
    if (this.isEmpty(str)){
      return   str;
    }else{
      return Number(str);
    }
  }
}
